// Boletos, Taxas, Customs
import React, { Component } from 'react';
import { formatAmount } from 'src/Common/utils';
import Card from './Card';
import Filters from '../Filters';

export default class Header extends Component {

    constructor(props){
        super(props);
        this.state = {
            showFilters: false
        };
        this.handleFiltersButtonClick = this.handleFiltersButtonClick.bind(this);
    }

    handleFiltersButtonClick(){
        const { showFilters } = this.state;
        this.setState({
            showFilters: !showFilters
        });
    }

    render(){
        const { billsAmount, fareAmount, customAmount, remnant_amount } = this.props
        const { showFilters } = this.state;

        return(
            <div className="header bg-gradient-default pb-8 pt-5 pt-md-8">
                <div className="container-fluid">
                    <div className="header-body">
                        <div className="row align-items-center py-4">
                            <div className="col-lg-6 col-7">
                                <h6 className="h2 text-white d-inline-block mb-0">
                                    Itens
                                </h6>
                                <div>
                                    <a
                                        href="javascript:void(0)"
                                        className="h4 pt-2 text-white"
                                        onClick={this.handleFiltersButtonClick}>
                                            <i className="fas fa-filter mr-2 text-sm" />
                                            Filtrar
                                    </a>
                                </div>
                            </div>
                            { showFilters &&
                                <Filters />
                            }
                        </div>
                        <div className="row">
                            <div className="col">
                                <Card
                                    loading={false}
                                    bgColor="bg-success"
                                    title="Valores"
                                    topUpperTitle="Items restantes"
                                    topUpperValue={formatAmount(remnant_amount)}
                                    leftUpperTitle="Boletos"
                                    leftUpperValue={formatAmount(billsAmount)}
                                    centerUpperTitle="Taxas"
                                    centerUpperValue={formatAmount(fareAmount)}
                                    rightUpperTitle="Avulsos"
                                    rightUpperValue={formatAmount(customAmount)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Items/Header/index.js